
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetomumbaitaxifare() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Taxi Fare',
        heading: 'Mauli Cabs: Pune to Mumbai Taxi Fare',
        headingDescription: 'Mauli Cabs offers affordable and transparent Pune to Mumbai taxi fare options, ensuring you get the best value for your ride. We provide a variety of well-maintained vehicles, including sedans, SUVs, and premium cabs, to suit your travel preferences and budget. With no hidden charges, clear pricing, and a strong focus on punctuality and customer satisfaction, Mauli Cabs guarantees a comfortable and stress-free ride from Pune to Mumbai, all at competitive and fair taxi fares.',

        top: 'Top Places to Visit in Mumbai with Mauli Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "The Gateway of India is an iconic monument located on the waterfront in South Mumbai. Built during the 20th century, it served as a ceremonial entrance to India for Viceroys and new Governors of Bombay."
    },
    {
        "title": "Marine Drive",
        "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6-kilometer-long boulevard along the South Mumbai coast. It's a perfect place for a scenic walk and offers stunning sunset views."
    },
    {
        "title": "Elephanta Caves",
        "description": "Elephanta Caves are a network of sculpted caves located on Elephanta Island, about 11 km from the city. They feature impressive rock-cut sculptures and are a UNESCO World Heritage Site."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "This UNESCO World Heritage Site is an outstanding example of Victorian Gothic Revival architecture in India, and it serves as one of Mumbai's busiest railway stations."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "The Siddhivinayak Temple is a revered Hindu temple dedicated to Lord Ganesha. Located in Prabhadevi, it attracts thousands of devotees daily seeking blessings."
    },
    {
        "title": "Colaba Causeway",
        "description": "Colaba Causeway is a vibrant shopping street lined with street stalls and boutiques selling clothes, jewelry, handicrafts, and antiques, making it a must-visit for shopaholics."
    },
    {
        "title": "Juhu Beach",
        "description": "Juhu Beach is one of Mumbai’s most famous beaches, popular for its street food, especially bhelpuri and pav bhaji, and for evening strolls along the Arabian Sea."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Located on an islet off the coast of Worli, the Haji Ali Dargah is a mosque and tomb built in memory of a wealthy Muslim merchant who gave up his worldly possessions before making a pilgrimage to Mecca."
    },
    {
        "title": "Chowpatty Beach",
        "description": "Chowpatty Beach is famous for its lively atmosphere, street food, and being a central spot for Ganesh Chaturthi celebrations where devotees immerse Ganesh idols in the sea."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, Sanjay Gandhi National Park is a green oasis offering trekking, a mini train ride, and a chance to visit the historic Kanheri Caves."
    }
],

"services": [
    {
      "name": "Pune to Mumbai Fare by Cab",
      "description": "Check current fare rates for cabs traveling from Pune to Mumbai. Transparent pricing without hidden fees."
    },
    {
      "name": "Pune to Mumbai Taxi Charges",
      "description": "Detailed breakdown of taxi charges for trips between Pune and Mumbai, including tolls and time-based pricing."
    },
    {
      "name": "Taxi Fare from Pune to Mumbai Airport",
      "description": "Get fare estimates for taxi rides to Mumbai Airport from Pune. Suitable for both Terminal 1 and Terminal 2."
    },
    {
      "name": "Pune to Mumbai Cheap Cabs",
      "description": "Affordable cab options from Pune to Mumbai. Great for budget-conscious travelers."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Top-rated cab services for Pune to Mumbai travel. Verified drivers and reliable vehicles."
    },
    {
      "name": "Best Cab Service from Pune to Mumbai Airport",
      "description": "Premium cab services for airport transfers from Pune to Mumbai. On-time service guaranteed."
    },
    {
      "name": "Best Mumbai Pune Cab Service",
      "description": "Highly recommended cab services for the Mumbai to Pune route with round-trip options."
    },
    {
      "name": "Best Pune to Mumbai Cab Service",
      "description": "Choose from top cab operators for your Pune to Mumbai journey with competitive fares."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Travel comfortably in a Maruti Ertiga cab from Pune to Mumbai. Ideal for groups and family trips."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Hire a Toyota Innova for travel from Pune to Mumbai. AC vehicles with ample space for passengers and luggage."
    },
    {
      "name": "Pune to Mumbai Round Trip Cab Fare",
      "description": "View fare details for round-trip cab journeys between Pune and Mumbai. Flexible return options available."
    },
    {
      "name": "Pune to Mumbai Shared Cab Fare",
      "description": "Budget-friendly shared cab fare from Pune to Mumbai. Ideal for solo travelers looking to save."
    },
    {
      "name": "Pune to Mumbai Innova Crysta Taxi Fare",
      "description": "Check fares for traveling in an Innova Crysta from Pune to Mumbai. Comfortable and spacious ride."
    },
    {
      "name": "Pune to Mumbai Airport Drop Innova Taxi Fare",
      "description": "Fare details for one-way Innova taxi drop from Pune to Mumbai Airport. Available 24/7."
    },
    {
      "name": "Pune to Mumbai Ertiga Taxi Fare",
      "description": "Affordable Ertiga taxi fare for the Pune to Mumbai route. Comfortable for up to 6 passengers."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Round-trip cab bookings from Pune to Mumbai. Ideal for business or leisure travelers."
    },
    {
      "name": "Pune to Mumbai Mauli Cabs Taxi Fare",
      "description": "Fare information for Mauli Cabs offering Pune to Mumbai service. Fixed prices and trained drivers."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Fare by Cab", "Pune to Mumbai Taxi Charges"],
    ["Taxi Fare from Pune to Mumbai Airport", "Pune to Mumbai Cheap Cabs"],
    ["Best Cab Service Pune to Mumbai", "Best Cab Service from Pune to Mumbai Airport"],
    ["Best Mumbai Pune Cab Service", "Best Pune to Mumbai Cab Service"],
    ["Pune to Mumbai Ertiga Cab", "Pune to Mumbai Innova Cab"],
    ["Pune to Mumbai Round Trip Cab Fare", "Pune to Mumbai Shared Cab Fare"],
    ["Pune to Mumbai Innova Crysta Taxi Fare", "Pune to Mumbai Airport Drop Innova Taxi Fare"],
    ["Pune to Mumbai Ertiga Taxi Fare", "Pune to Mumbai Cab Round Trip"],
    ["Pune to Mumbai Mauli Cabs Taxi Fare", "Pune to Mumbai Fare by Cab"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Flexible Car Hire Options",
        "WhyChoosedescription": "Mauli Cabs offers flexible car hire services between Pune and Mumbai, allowing you to choose from hourly, daily, or one-way rentals based on your travel needs."
    },
    {
        "WhyChooseheading": "Wide Range of Cars",
        "WhyChoosedescription": "Hire from a broad fleet including hatchbacks, sedans, SUVs, and premium vehicles. Whether you're traveling solo or with a group, we have the perfect car for you."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, polite, and experienced in the Pune-Mumbai route, ensuring a safe, smooth, and enjoyable ride every time."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Rates",
        "WhyChoosedescription": "Enjoy competitive pricing with no hidden costs. Our Pune to Mumbai car hire service offers clear, all-inclusive rates for peace of mind."
    },
    {
        "WhyChooseheading": "Ideal for Business or Leisure Travel",
        "WhyChoosedescription": "Whether you're heading to Mumbai for a business meeting or a weekend getaway, our car hire service is tailored to suit both personal and corporate travel needs."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop",
        "WhyChoosedescription": "We offer convenient pickup and drop-off at your doorstep in Pune and Mumbai. No need to travel to a rental office—your car comes to you."
    },
    {
        "WhyChooseheading": "24/7 Availability and Booking",
        "WhyChoosedescription": "Our Pune-Mumbai car hire services are available 24/7. You can book anytime via our website or app, with instant confirmation and support."
    },
    {
        "WhyChooseheading": "Safe, Clean, and GPS-Enabled Vehicles",
        "WhyChoosedescription": "All cars are sanitized before every ride, GPS-equipped, and driven by background-verified drivers to ensure a safe and reliable travel experience."
    }
]























    }


    const faqData = [
        {
            question: 'What is the taxi fare from Pune to Mumbai with Mauli Cabs?',
            answer: 'Mauli Cabs offers fixed and affordable taxi fares from Pune to Mumbai. The fare depends on the vehicle type you choose—Hatchback, Sedan, SUV, or Innova Crysta—and includes tolls, driver allowance, and fuel charges. No hidden fees are added.',
        },
        {
            question: 'Is the Pune to Mumbai taxi fare inclusive of tolls and taxes?',
            answer: 'Yes, the displayed fare includes tolls, taxes, fuel, and driver charges. We believe in complete fare transparency so that you know exactly what you’re paying for.',
        },
        {
            question: 'How can I check the exact fare for Pune to Mumbai before booking?',
            answer: 'You can check the fare directly on our website or app by entering your pickup and drop locations and selecting the vehicle type. The total price will be shown before you confirm the booking.',
        },
        {
            question: 'Does the taxi fare vary by time or day?',
            answer: 'Our fares are mostly fixed, but minor differences may apply during high-demand periods like weekends, holidays, or peak hours. These are always shown upfront during booking.',
        },
        {
            question: 'Are there different fares for one-way and round-trip bookings?',
            answer: 'Yes, one-way and round-trip bookings have different pricing structures. Round trips are usually more cost-effective if you plan to return the same or next day.',
        },
        {
            question: 'Can I get a bill or receipt for the Pune to Mumbai taxi fare?',
            answer: 'Yes, Mauli Cabs provides a detailed invoice for every trip. The bill includes fare breakdowns, taxes, and other applicable charges, and is shared via email or app after the trip.',
        },
        {
            question: 'Is there any surge pricing for last-minute Pune to Mumbai bookings?',
            answer: 'No, we do not apply surge pricing. Even for last-minute bookings, our fare remains transparent and competitive, depending on vehicle availability.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Swapnil Wagh",
            position: "Daily Commuter",
            text: "I’ve used Mauli Cabs multiple times for Pune to Mumbai trips. Their fares are always reasonable and clearly communicated—no surprises. Great value for money!",
            image: "/img/testimonial/testimonial-thumb-1-27.png",
        },
        {
            name: "Miss. Tanvi Gokhale",
            position: "Media Professional",
            text: "Booked a cab from Pune to Mumbai last minute and was impressed with the fixed fare policy. No hidden charges and very comfortable ride. Highly trustworthy service.",
            image: "/img/testimonial/testimonial-thumb-1-28.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mumbai Taxi Fare by Mauli Cabs",
        "description": "Mauli Cabs offers transparent and competitive taxi fare from Pune to Mumbai. Whether you're booking a one-way or round trip, our fare structure is affordable and clear. Choose from a variety of vehicles, including Innova, Ertiga, and more for your travel convenience.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "4500"
        }
      };
      
      
      

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Mumbai Taxi Fare | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Check the affordable Pune to Mumbai taxi fare with Mauli Cabs. Get the best price for your one-way or round trip. Book cabs with transparent fare and excellent service."
        />
        <meta
          name="keywords"
          content="pune to mumbai fare by cab, pune to mumbai taxi charges, taxi fare from pune to mumbai airport, pune to mumbai cheap cabs, best cab service pune to mumbai, best cab service from pune to mumbai airport, pune to mumbai innova crysta taxi fare, pune to mumbai round trip cab fare, pune to mumbai shared cab fare, pune to mumbai taxi charges, taxi fare from pune to mumbai airport"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaitaxifare;